export const blackColor = '#000';
export const darkGray = '#333';
export const transparent = 'transparent';

export {default as accent} from './accent';
export {default as primary} from './primary';
export {default as neutrals} from './neutrals';
export {default as secondary} from './secondary';
export {default as feedback} from './feedback';
